import React from "react"
import {
    Modal,
    ModalTitle,
    TitleSection,
    ContentSection,
    FooterSection,
    Label,
    Button,
    Row,
    Column,
    Color,
} from "trux"
import { useHistory } from "react-router-dom"

export const RemoveFamily = (props) => {
    const history = useHistory()

    const handleCloseButtonClick = (e) => {
        e.preventDefault()
        history.goBack()
    }

    return (
        <Modal
            className="RemoveFamily"
            open
            onShadeClick={(e) => {
                handleCloseButtonClick(e)
            }}
        >
            <TitleSection onCloseClick={handleCloseButtonClick}>
                <ModalTitle content={"Remove family member?"} />
            </TitleSection>
            <ContentSection>
                <Label
                    center
                    type={Label.Type.Body}
                    color={Color.Charcoal40}
                    marginBottom="4"
                    content="You will remove this family member from your Trace family.
                    You can always invite them back if you need to."
                />
            </ContentSection>
            <FooterSection>
                <Button
                    width="100%"
                    className="cancel-button"
                    content={"No, cancel"}
                />

                <Button
                    width="100%"
                    className="remove-button"
                    content={"Yes, remove family member"}
                />
            </FooterSection>
        </Modal>
    )
}
